export default "__VITE_ASSET__jCD5yY5U__"